export var UserFlowIds;
(function (UserFlowIds) {
    UserFlowIds["CategoriesCustomisation"] = "categories_customisation";
})(UserFlowIds || (UserFlowIds = {}));
